function getDefaultColorDepth() {
    return 1;
}
function getCaptureActivator() {
    throw new Error(`The enableCapture option cannot be used from within a browser environment`);
}

export { getCaptureActivator, getDefaultColorDepth };
